// Hooks
import apiGetDeps from "@/hooks/requests/apiGetDeps/apiGetDeps";
import { useBuyDeviceStore } from "@/stores/buyDevice/buyDevice";
// Store
import { useChooseDeviceStore } from "@/stores/chooseDevice/chooseDevice";
import { useTIWStore } from "@/stores/tiw/tiw";

/** Загрузить Бренды */
export default async function useBrands(): Promise<void> {
    const ChooseDeviceStore = useChooseDeviceStore();
    const BuyDeviceStore = useBuyDeviceStore();
    const TIWStore = useTIWStore();

    const brandsData = await apiGetDeps(TIWStore.WIDGET_DATA.token);
    // console.log(brandsData.data.brands);

    // ChooseDeviceStore

    ChooseDeviceStore.brands = brandsData.data.brands
        .filter((el) => {
            return el.name.toLocaleLowerCase() !== "other brands";
        })
        .map((el) => {
            return {
                ...el,
                name: el.name.charAt(0).toUpperCase() + el.name.slice(1).toLowerCase(),
            };
        })
        .sort((a, b) => {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
            return 1;
        });
    ChooseDeviceStore.categories = brandsData.data.categories;
    ChooseDeviceStore.brandsCategories = brandsData.data.brands_categories;

    BuyDeviceStore.field_brand.data = brandsData.data.brands;

    BuyDeviceStore.manualCharacteristicsData.brand = brandsData.data.brands;
    BuyDeviceStore.manualCharacteristicsData.brand_categories = brandsData.data.brands_categories;
    BuyDeviceStore.manualCharacteristicsData.category = brandsData.data.categories;
}
